__turbopack_context__.v({
  "controls": "style-module-scss-module__czAb2G__controls",
  "listContainer": "style-module-scss-module__czAb2G__listContainer",
  "showMoreBtn": "style-module-scss-module__czAb2G__showMoreBtn",
  "showMoreWrapper": "style-module-scss-module__czAb2G__showMoreWrapper",
  "wrapper": "style-module-scss-module__czAb2G__wrapper",
});
